import { SUPPORT_URL } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const ChunksErrorThresholdError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Oh dear'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          There was an error recording your mote. Please try again, or search
          our FAQ pages for troubleshooting suggestions.
        </Text>
      }
      buttons={
        <>
          <Button
            onClick={() => onClose()}
            variant='secondary'
            text='Dismiss'
          />
          <Button
            onClick={() => {
              window.open(SUPPORT_URL, '_blank')
            }}
            text='Learn more'
          />
        </>
      }
    />
  )
}

export const ChunkUploadError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Oh dear'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Slow or no internet connection. Please check your internet settings.
        </Text>
      }
      buttons={
        <>
          <Button
            onClick={() => onClose()}
            variant='secondary'
            text='Dismiss'
          />
          <Button
            onClick={() => {
              window.open(SUPPORT_URL, '_blank')
            }}
            text='Learn more'
          />
        </>
      }
    />
  )
}
